import React from "react";
import { Container, Button } from "shards-react";
import { Link } from "react-router-dom";
import { strings } from "../localization";

const Errors = props => (
  <Container fluid className="vh-100 d-flex justify-content-center align-items-center">
    <div className="error">
      <div className="error__content">
        <h2>{props.number}</h2>
        <p>{props.message}</p>
        <h4>{props.text}</h4>
        {/* <Link to="/">
          <Button pill>&larr; {strings.go_to_home}</Button>
        </Link> */}
      </div>
    </div>
  </Container>
);

export default Errors;
